module.exports = __webpack_public_path__ + "static/media/EstadoAgenteNotas.9c64f96b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/EstadoAgente/EstadoAgenteNotas.svg
// module id = 1770
// module chunks = 0